(function () {
  'use strict';
  var root = document.querySelector('.tmb-hub[data-endpoint]');
  if (!root) return;
  var endpoint = root.getAttribute('data-endpoint') || '';
  var form     = root.querySelector('.tmb-hub-form');
  var emailEl  = root.querySelector('#tmb-hub-email');
  var tokenEl  = root.querySelector('#tmb-hub-token');
  var toggleEl = root.querySelector('[data-hub-coach-toggle]');
  var submitEl = root.querySelector('.tmb-hub-submit');
  var statusEl = root.querySelector('[data-hub-status]');
  var resultsEl = root.querySelector('[data-hub-results]');
  if (!form || !emailEl || !resultsEl) return;

  var TOKEN_STORAGE_KEY = 'tmb_hub_trainer_token';
  // Athlete-side memory: remember the last email that returned plans so
  // the cross-plan dropdown on the plan page can populate without
  // re-asking. Cleared if a lookup returns zero plans (stale email).
  var EMAIL_STORAGE_KEY = 'tmb_hub_email';
  // Per-plan filter, which plans contribute to the merged Today + Week
  // views. Stored as JSON: { '<planToken>': false } means EXCLUDED.
  // Default (no entry) = included. Plan tokens are derived from the
  // plan's pageUrl ?token= query param.

  // #110, sessionStorage cache shared with hub + plan-page chip + merged
  // page. Same key, same 5-min TTL. Repeat lookups within the window
  // don't hit /exec (which contributed to the daily-cap rate limit).
  function __readLookupCache_(email) {
    try {
      var raw = sessionStorage.getItem('tmb_lookup_cache');
      if (!raw) return null;
      var c = JSON.parse(raw);
      if (!c || c.email !== email) return null;
      if (Date.now() - (c.at || 0) > 5 * 60 * 1000) return null;
      return c.data;
    } catch (_e) { return null; }
  }
  function __writeLookupCache_(email, data) {
    try { sessionStorage.setItem('tmb_lookup_cache', JSON.stringify({ email: email, at: Date.now(), data: data })); }
    catch (_e) {}
  }
  var FILTER_STORAGE_KEY = 'tmb_hub_plan_filter';
  function readPlanFilter_() {
    try { return JSON.parse(localStorage.getItem(FILTER_STORAGE_KEY) || '{}'); }
    catch (_e) { return {}; }
  }
  function writePlanFilter_(filter) {
    try { localStorage.setItem(FILTER_STORAGE_KEY, JSON.stringify(filter)); }
    catch (_e) {}
  }
  function planIsIncluded_(token, filter) {
    if (!token) return true;
    var v = filter && filter[token];
    return v !== false;  // missing key OR true → included
  }
  function readSavedToken_() {
    try { return localStorage.getItem(TOKEN_STORAGE_KEY) || ''; } catch (_e) { return ''; }
  }
  function saveToken_(t) {
    try { if (t) localStorage.setItem(TOKEN_STORAGE_KEY, t); else localStorage.removeItem(TOKEN_STORAGE_KEY); } catch (_e) {}
  }
  function saveEmail_(e) {
    try { if (e) localStorage.setItem(EMAIL_STORAGE_KEY, e); else localStorage.removeItem(EMAIL_STORAGE_KEY); } catch (_e) {}
  }
  // Remember-this-device token from a verified code exchange. Access is
  // code-gated server-side; this token is what lets a returning visitor skip
  // the code for ~45 days. Cleared alongside the email on a failed re-auth.
  var DEVICE_STORAGE_KEY = 'tmb_hub_device';
  function getDevice_() { try { return localStorage.getItem(DEVICE_STORAGE_KEY) || ''; } catch (_e) { return ''; } }
  function saveDevice_(t) {
    try { if (t) localStorage.setItem(DEVICE_STORAGE_KEY, t); else localStorage.removeItem(DEVICE_STORAGE_KEY); } catch (_e) {}
  }
  // Two-step form state. pendingEmail/pendingToken carry the email step's values
  // into the code step.
  var pendingEmail = '';
  var pendingToken = '';
  var emailSubmitEl = root.querySelector('[data-hub-email-submit]');
  var codeSubmitEl  = root.querySelector('[data-hub-code-submit]');
  var codeEl        = root.querySelector('#tmb-hub-code');
  var stepEmailEl   = root.querySelector('[data-hub-step-email]');
  var stepCodeEl    = root.querySelector('[data-hub-step-code]');
  var codeSentEl    = root.querySelector('[data-hub-code-sent]');
  function showStep_(step) {
    if (!form) return;
    form.setAttribute('data-hub-step', step);
    if (stepEmailEl) stepEmailEl.hidden = (step !== 'email');
    if (stepCodeEl)  stepCodeEl.hidden  = (step !== 'code');
    if (step === 'code' && codeEl) { try { codeEl.value = ''; setTimeout(function () { codeEl.focus(); }, 30); } catch (_e) {} }
    if (step === 'email' && emailEl) { try { setTimeout(function () { emailEl.focus(); }, 30); } catch (_e) {} }
  }
  function requestCode_(email) {
    return fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      body: JSON.stringify({ action: 'requestAccessCode', email: email }),
    }).then(function (r) { return r.json(); });
  }
  // Prefill the trainer token from localStorage so verified coaches
  // don't have to re-paste on every visit. Open the disclosure if
  // we have one stashed.
  var savedToken = readSavedToken_();
  if (savedToken && tokenEl) {
    tokenEl.value = savedToken;
    if (toggleEl) toggleEl.open = true;
  }

  function setStatus_(msg, kind) {
    if (!statusEl) return;
    statusEl.textContent = msg || '';
    statusEl.className = 'tmb-hub-status' + (kind ? ' is-' + kind : '');
  }

  function escapeHtml_(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function groupTypeLabel_(gt) {
    var g = String(gt || '').toLowerCase();
    if (g === 'gym') return 'Gym';
    if (g === 'large_group') return 'Broadcast group';
    if (g === 'small_group') return 'Small group';
    return 'Individual plan';
  }

  function planLink_(p, email) {
    var url = p.pageUrl || '';
    if (!url) return '';
    // The plan page's email gate auto-confirms when ?email=… matches
    // a registered email/member. Pass it through so the user lands
    // straight on their plan instead of the gate screen.
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    return url + sep + 'email=' + encodeURIComponent(email);
  }

  function render_(data, email) {
    var html = '';
    var nothing = !(data.trainer || (data.plans && data.plans.length)) && !data.trainerPending;

    if (data.trainer) {
      html += '<div class="tmb-hub-card tmb-hub-trainer-card">' +
        '<div class="tmb-hub-card-eyebrow">Coach</div>' +
        '<div class="tmb-hub-card-title">' + escapeHtml_(data.trainer.name || 'Coach') +
          ' <span class="tmb-hub-card-role tmb-hub-role-' + escapeHtml_(data.trainer.role || 'trainer') + '">' +
          escapeHtml_(String(data.trainer.role || 'trainer').toUpperCase()) + '</span></div>' +
        '<div class="tmb-hub-card-body">' +
          'You\'re registered as a coach. Open your dashboard to manage athletes, groups, and gyms.' +
        '</div>' +
        '<a class="tmb-hub-card-cta" href="' + escapeHtml_(data.trainer.coachPageUrl || '#') +
          '?email=' + encodeURIComponent(email) +
          '">Open coach dashboard →</a>' +
      '</div>';
    } else if (data.trainerPending) {
      html += '<div class="tmb-hub-card tmb-hub-trainer-pending">' +
        '<div class="tmb-hub-card-eyebrow">Coach</div>' +
        '<div class="tmb-hub-card-title">Trainer token required</div>' +
        '<div class="tmb-hub-card-body">' +
          'This email is registered as a coach. To unlock the coach dashboard, expand <strong>I\'m a coach</strong> above, paste your trainer token, then click <strong>Find my plans</strong> again.' +
        '</div>' +
        '<div class="tmb-hub-card-actions">' +
          '<button type="button" class="tmb-hub-resend" data-resend-email="' + escapeHtml_(email) + '">Resend welcome email</button>' +
          '<span class="tmb-hub-card-meta tmb-hub-resend-status" data-resend-status></span>' +
        '</div>' +
      '</div>';
    }

    var plans = (data.plans || []).slice();
    if (plans.length) {
      html += '<h2 class="tmb-hub-section-heading">Your plans (' + plans.length + ')</h2>';
      // Sort: individual first, then groups by title.
      plans.sort(function (a, b) {
        var ka = (a.role === 'athlete' ? '0' : '1') + (a.planTitle || '').toLowerCase();
        var kb = (b.role === 'athlete' ? '0' : '1') + (b.planTitle || '').toLowerCase();
        return ka < kb ? -1 : ka > kb ? 1 : 0;
      });
      plans.forEach(function (p) {
        html += '<div class="tmb-hub-card tmb-hub-plan-row">' +
          '<div class="tmb-hub-plan-row-main">' +
            '<div class="tmb-hub-card-eyebrow">' + escapeHtml_(groupTypeLabel_(p.groupType)) + '</div>' +
            '<div class="tmb-hub-card-title">' + escapeHtml_(p.planTitle || p.athleteName || 'Plan') + '</div>' +
            (p.role === 'member' && p.memberName ?
              '<div class="tmb-hub-card-meta">Joined as ' + escapeHtml_(p.memberName) + '</div>' : '') +
            (p.pageUrl ? '' :
              '<div class="tmb-hub-card-meta">Plan link not configured yet. Ask your coach.</div>') +
          '</div>' +
          (p.pageUrl ?
            '<a class="tmb-hub-card-cta" href="' + escapeHtml_(planLink_(p, email)) + '">Open plan →</a>' : '') +
        '</div>';
      });
    }

    if (nothing) {
      html += '<div class="tmb-hub-empty">' +
        '<p><strong>No plans found for that email.</strong></p>' +
        '<p>If you signed up via the public signup page, double-check the email you used. If you should have access through a coach, ask them which email they registered.</p>' +
        '</div>';
    }

    resultsEl.innerHTML = html;

    // Wire the resend-welcome-email button on the trainer-pending card.
    var resendBtn = resultsEl.querySelector('.tmb-hub-resend');
    if (resendBtn) {
      resendBtn.addEventListener('click', function () {
        var em = resendBtn.getAttribute('data-resend-email') || '';
        if (!em) return;
        var statusSpan = resultsEl.querySelector('[data-resend-status]');
        resendBtn.disabled = true; resendBtn.innerHTML = '<span class="tmb-hub-spin" aria-hidden="true"></span>Sending…';
        if (statusSpan) statusSpan.textContent = '';
        fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
          body: JSON.stringify({ action: 'recoverTrainerToken', email: em }),
        })
          .then(function (r) { return r.json(); })
          .then(function (j) {
            // Server returns a generic ok message regardless of whether
            // the email matched, by design, so we don't leak which
            // emails are registered. Mirror that in the UI.
            if (statusSpan) {
              statusSpan.textContent = (j && j.message) ||
                'If that email matches a coach account, the welcome email is on its way. Check spam.';
            }
            resendBtn.textContent = 'Sent';
            // Stay disabled, re-enable after a cooldown so the user
            // can re-trigger if needed but not spam-click.
            setTimeout(function () {
              resendBtn.disabled = false;
              resendBtn.textContent = 'Resend welcome email';
            }, 60000);
          })
          .catch(function () {
            if (statusSpan) statusSpan.textContent = 'Network error. Try again.';
            resendBtn.disabled = false;
            resendBtn.textContent = 'Resend welcome email';
          });
      });
    }
  }

  // Step 1, email → request a 6-digit code. Anti-enumeration: the server's
  // reply is identical whether or not the email has plans, so we always advance
  // to the code step.
  function submitEmailStep_() {
    var email = (emailEl.value || '').trim().toLowerCase();
    if (!email) { emailEl.focus(); return; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setStatus_('That doesn\'t look like a valid email.', 'error');
      return;
    }
    if (!endpoint) {
      setStatus_('Sign-in endpoint not configured. Ask the site admin.', 'error');
      return;
    }
    pendingEmail = email;
    pendingToken = tokenEl ? (tokenEl.value || '').trim() : '';
    if (emailSubmitEl) { emailSubmitEl.disabled = true; emailSubmitEl.innerHTML = '<span class="tmb-hub-spin" aria-hidden="true"></span>Sending…'; }
    setStatus_('', '');
    resultsEl.innerHTML = '';
    requestCode_(email)
      .then(function () {
        if (codeSentEl) codeSentEl.textContent = 'We\'ve emailed a 6-digit code to ' + email + '. It expires in 15 minutes.';
        showStep_('code');
      })
      .catch(function (err) {
        try { window.tmbLogError && window.tmbLogError('fetch_requestcode_hub', String(err && err.message || err), { stack: err && err.stack || '', email: email }); } catch (_e) {}
        setStatus_('Network error. Please try again.', 'error');
      })
      .then(function () { if (emailSubmitEl) { emailSubmitEl.disabled = false; emailSubmitEl.textContent = 'Email me a code'; } });
  }

  // Step 2, code → verify. On success we get the plan list + a device token.
  function submitCodeStep_() {
    var code = (codeEl && codeEl.value || '').replace(/\s+/g, '');
    if (!/^\d{6}$/.test(code)) {
      setStatus_('Enter the 6-digit code from your email.', 'error');
      if (codeEl) codeEl.focus();
      return;
    }
    if (codeSubmitEl) { codeSubmitEl.disabled = true; codeSubmitEl.innerHTML = '<span class="tmb-hub-spin" aria-hidden="true"></span>Checking…'; }
    setStatus_('', '');
    var body = { action: 'verifyAccessCode', email: pendingEmail, code: code };
    if (pendingToken) body.trainerToken = pendingToken;
    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      body: JSON.stringify(body),
    })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (!j || !j.ok) {
          setStatus_((j && j.message) || 'That code is wrong or has expired. Try again or email a new one.', 'error');
          return;
        }
        saveDevice_(j.deviceToken || '');
        var hasAccess = !!(j.trainer || (j.plans && j.plans.length));
        saveEmail_(hasAccess ? pendingEmail : '');
        if (j.trainer) saveToken_(j.trainer.token || pendingToken);
        else if (pendingToken && j.trainerPending) saveToken_('');
        setStatus_('', '');
        // Coaches get their dashboard card via render_; athletes get the nicer
        // combined "today across your plans" view that returning visitors see.
        if (j.trainer) {
          render_(j, pendingEmail);
        } else {
          autoLoadMergedView_();
        }
      })
      .catch(function (err) {
        try { window.tmbLogError && window.tmbLogError('fetch_verifycode_hub', String(err && err.message || err), { stack: err && err.stack || '', email: pendingEmail }); } catch (_e) {}
        setStatus_('Network error. Please try again.', 'error');
      })
      .then(function () { if (codeSubmitEl) { codeSubmitEl.disabled = false; codeSubmitEl.textContent = 'Open my plans'; } });
  }

  form.addEventListener('submit', function (ev) {
    ev.preventDefault();
    if (form.getAttribute('data-hub-step') === 'code') submitCodeStep_();
    else submitEmailStep_();
  });
  var resendBtn_ = root.querySelector('[data-hub-resend-code]');
  if (resendBtn_) resendBtn_.addEventListener('click', function () {
    if (!pendingEmail) { showStep_('email'); return; }
    setStatus_('', '');
    resendBtn_.disabled = true; var orig = resendBtn_.textContent; resendBtn_.textContent = 'Sending…';
    requestCode_(pendingEmail)
      .then(function () { if (codeSentEl) codeSentEl.textContent = 'New code sent to ' + pendingEmail + '. It expires in 15 minutes.'; })
      .catch(function () { setStatus_('Network error. Please try again.', 'error'); })
      .then(function () { resendBtn_.disabled = false; resendBtn_.textContent = orig; });
  });
  var changeBtn_ = root.querySelector('[data-hub-change-email]');
  if (changeBtn_) changeBtn_.addEventListener('click', function () { setStatus_('', ''); showStep_('email'); });

  // Convenience: prefill from ?email=… in the URL (useful for confirm-and-open
  // welcome-email links that land users here).
  try {
    var p = new URLSearchParams(window.location.search);
    var pre = p.get('email');
    if (pre && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(pre.trim())) {
      emailEl.value = pre.trim();
      // Auto-submit if URL says ?email=...&auto=1
      if (p.get('auto') === '1') form.dispatchEvent(new Event('submit'));
    }
  } catch (_e) { /* ignore */ }

  // ── PHASE 3. MERGED TODAY PANEL ────────────────────────────────────────────
  // When the visitor has a previously-verified email persisted, auto-render
  // the merged today panel showing all today's sessions across all their
  // plans. The card-list (rendered by render_ above) becomes a fallback the
  // visitor only sees when they explicitly use the form.

  var DAY_CODES = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
  var SLOT_ORDER = { 'am': 1, 'all day': 2, 'pm': 3, 'focus': 4 };

  // Hash a plan name to a stable pastel HSL color. Deterministic so the
  // same plan always reads as the same color across the today panel +
  // the plan-page chip.
  function planColor_(name) {
    var s = String(name || '');
    if (__planColorByName_[s]) return __planColorByName_[s];
    var h = 0;
    for (var i = 0; i < s.length; i++) h = ((h << 5) - h + s.charCodeAt(i)) | 0;
    var hue = Math.abs(h) % 360;
    // De-collide: hash collisions were giving several plans the same
    // colour. Nudge by golden-angle steps until this hue sits at least
    // 26 degrees from every hue already assigned this pageload.
    function clashes_(cand) {
      return __planHues_.some(function (u) {
        var d = Math.abs(cand - u) % 360;
        return Math.min(d, 360 - d) < 26;
      });
    }
    var guard = 0;
    while (clashes_(hue) && guard++ < 14) hue = (hue + 137) % 360;
    __planHues_.push(hue);
    __planColorByName_[s] = 'hsl(' + hue + ', 55%, 48%)';
    return __planColorByName_[s];
  }
  var __planHues_ = [];
  var __planColorByName_ = {};

  // Fetch plans a few at a time instead of all at once. Nine simultaneous
  // GETs against one Apps Script /exec trip its concurrent-invocation
  // limits and cold-start several of them into the 20s abort, which is
  // how "4 of 9 plans failed to load" happens. Three lanes keep the
  // server warm without the stampede, and one sequential retry pass
  // picks up stragglers once the container is hot.
  function fetchPlansLimited_(items, worker) {
    var results = new Array(items.length);
    var next = 0;
    function lane() {
      var i = next++;
      if (i >= items.length) return Promise.resolve();
      return worker(items[i], i).then(function (res) { results[i] = res; return lane(); });
    }
    var lanes = [];
    for (var k = 0; k < Math.min(3, items.length); k++) lanes.push(lane());
    return Promise.all(lanes).then(function () { return results; });
  }

  function tokenFromPageUrl_(pageUrl) {
    if (!pageUrl) return '';
    try {
      var u = new URL(pageUrl, window.location.origin);
      return u.searchParams.get('token') || '';
    } catch (_e) {}
    var m = /[?&]token=([^&]+)/.exec(pageUrl);
    return m ? decodeURIComponent(m[1]) : '';
  }

  // Per-plan version+data cache. localStorage (not sessionStorage) so
  // the cache survives tab close → next-day re-open, giving the hub an
  // instant first paint on repeat visits. Server's ?_seen= short-circuit
  // revalidates the snapshot in the background.
  var PLAN_DATA_CACHE_KEY_ = 'tmb_hub_plan_data:';
  function readCachedPlanData_(token) {
    try {
      var raw = localStorage.getItem(PLAN_DATA_CACHE_KEY_ + token);
      if (!raw) return null;
      var c = JSON.parse(raw);
      return (c && c.version && c.data) ? c : null;
    } catch (_e) { return null; }
  }
  function writeCachedPlanData_(token, version, data) {
    try {
      localStorage.setItem(
        PLAN_DATA_CACHE_KEY_ + token,
        JSON.stringify({ version: version, data: data, at: Date.now() })
      );
    } catch (_e) {}
  }

  // Fetch one plan's data via GET. Windowed to TODAY ONLY since the
  // hub only renders today's sessions per plan, full plan history is
  // never shown here. Pairs with windowPlan_(plan, fromIso, days) on
  // the server. Cache key includes the iso so yesterday's window
  // doesn't leak forward. (#65 perf)
  function fetchPlanData_(token, email) {
    var fromIso = todayIso_();
    var cacheKey = token + ':' + fromIso + ':1';
    var cached = readCachedPlanData_(cacheKey);
    var url = endpoint + '?token=' + encodeURIComponent(token) +
      '&days=1&fromIso=' + encodeURIComponent(fromIso) +
      '&_=' + Date.now();
    if (email) url += '&email=' + encodeURIComponent(email);
    return fetch(url, { method: 'GET' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (!j || !j.ok) return cached && cached.data ? cached.data : null;
        if (j.planVersion) writeCachedPlanData_(cacheKey, String(j.planVersion), j.data);
        return j.data;
      })
      .catch(function () { return cached && cached.data ? cached.data : null; });
  }

  // Today's day code in the visitor's local tz. Different plans can run
  // in different timezones but cross-plan view uses the visitor's clock,
  // edge case Mike accepted in Phase 3 spec.
  function todayDayCode_() { return DAY_CODES[new Date().getDay()]; }
  function todayIso_()     {
    var d = new Date();
    var y = d.getFullYear();
    var m = String(d.getMonth() + 1).padStart(2, '0');
    var dd = String(d.getDate()).padStart(2, '0');
    return y + '-' + m + '-' + dd;
  }

  // For one plan's payload, find this calendar week (Start ≤ today ≤ End)
  // and return today's sessions. Returns [] if today isn't in any week
  // (pre-plan or post-plan).
  function todaySessionsForPlan_(plan) {
    if (!plan || !plan.imports || !plan.weeks) return [];
    var today = todayIso_();
    var todayDay = todayDayCode_();
    var thisWeek = plan.weeks.find(function (w) {
      var s = String(w['Start Date'] || '').slice(0, 10);
      var e = String(w['End Date'] || '').slice(0, 10);
      return s && e && s <= today && today <= e;
    });
    if (!thisWeek) return [];
    var weekId = String(thisWeek.Week || '');
    return plan.imports.filter(function (r) {
      return String(r.Week) === weekId &&
        String(r.Day || '').toLowerCase() === todayDay;
    });
  }

  // Strip the internal "Plan, " prefix that Directory titles carry,
  // since the page already lives at "Your training plans". Athletes
  // shouldn't see the system jargon, they see plan names directly.
  function athleteFacingPlanName_(s) {
    return String(s || '').replace(/^Plan\s*[—–·-]\s*/i, '').trim() || 'Plan'; // em-dash-ok: strips the prefix from titles STORED before the sweep
  }
  // Only show the slot chip when it's one of the canonical buckets a
  // customer recognises. Trainer-typed values like "MAIN" / "PRIMARY"
  // are meaningless to athletes, drop them.
  var SLOT_DISPLAY_ = { 'am': 'AM', 'pm': 'PM', 'all day': 'All day', 'focus': 'Focus' };
  function displaySlot_(raw) {
    var key = String(raw || '').trim().toLowerCase();
    return SLOT_DISPLAY_[key] || '';
  }
  function renderSessionCard_(session, plan, planMeta, email) {
    var color = planColor_(planMeta.planTitle);
    var slot = displaySlot_(session.Slot);
    var titleStr = String(session.Title || session.Category || 'Session');
    var planName = athleteFacingPlanName_(planMeta.planTitle);
    // Compact meta: category + duration only. Internal jargon like
    // P1 / Priority codes are stripped, athletes don't need that.
    var meta = [];
    if (session.Category && String(session.Category).toLowerCase() !== titleStr.toLowerCase()) {
      meta.push(String(session.Category));
    }
    if (session['Duration (min)']) meta.push(session['Duration (min)'] + ' min');
    var sep = planMeta.pageUrl && planMeta.pageUrl.indexOf('?') === -1 ? '?' : '&';
    var href = planMeta.pageUrl ? planMeta.pageUrl + sep + 'email=' + encodeURIComponent(email) : '#';
    return '<a class="tmb-hub-today-card" href="' + escapeHtml_(href) + '" ' +
      'style="--plan-color: ' + color + '">' +
      '<span class="tmb-hub-today-card-strip"></span>' +
      '<span class="tmb-hub-today-card-body">' +
        '<span class="tmb-hub-today-card-row">' +
          '<span class="tmb-hub-today-card-title">' + escapeHtml_(titleStr) + '</span>' +
          (meta.length ? '<span class="tmb-hub-today-card-meta">' + escapeHtml_(meta.join(' · ')) + '</span>' : '') +
        '</span>' +
        '<span class="tmb-hub-today-card-plan">' + escapeHtml_(planName) + '</span>' +
      '</span>' +
      (slot ? '<span class="tmb-hub-today-card-slot">' + escapeHtml_(slot) + '</span>' : '') +
    '</a>';
  }

  function renderMergedToday_(planEntries, email) {
    // planEntries = [{ planMeta, planData }]
    var filter = readPlanFilter_();
    var allCards = [];
    planEntries.forEach(function (e) {
      if (!e.planData) return;
      var token = tokenFromPageUrl_(e.planMeta.pageUrl) || '';
      if (!planIsIncluded_(token, filter)) return;
      var sessions = todaySessionsForPlan_(e.planData);
      sessions.forEach(function (s) {
        allCards.push({ session: s, planMeta: e.planMeta, planData: e.planData });
      });
    });
    // Sort: AM → All day → PM → Focus, then by Priority within slot.
    allCards.sort(function (a, b) {
      var sa = (SLOT_ORDER[String(a.session.Slot || 'all day').toLowerCase()] || 5);
      var sb = (SLOT_ORDER[String(b.session.Slot || 'all day').toLowerCase()] || 5);
      if (sa !== sb) return sa - sb;
      var pa = String(a.session.Priority || 'P3');
      var pb = String(b.session.Priority || 'P3');
      return pa < pb ? -1 : pa > pb ? 1 : 0;
    });
    // Personal status line. "X sessions today · Y plans", gives the
    // athlete a glance at their day before they read the cards.
    var sessionCountTxt = allCards.length === 0 ? 'No sessions'
      : allCards.length === 1 ? '1 session'
      : allCards.length + ' sessions';
    var planCountTxt = planEntries.length + (planEntries.length === 1 ? ' plan' : ' plans');
    var html = '<section class="tmb-hub-today">' +
      '<header class="tmb-hub-today-header">' +
        '<h2 class="tmb-hub-today-title">Today</h2>' +
        '<span class="tmb-hub-today-sub">' +
          escapeHtml_(new Date().toLocaleDateString(undefined, { weekday: 'long', day: 'numeric', month: 'long' })) +
        '</span>' +
        '<span class="tmb-hub-today-status">' +
          sessionCountTxt + ' today · ' + planCountTxt +
        '</span>' +
      '</header>';
    if (!allCards.length) {
      html += '<div class="tmb-hub-today-empty">Nothing planned today across your plans. ' +
        '<a href="#" data-hub-show-plans>See all plans →</a></div>';
    } else {
      html += '<div class="tmb-hub-today-cards">' +
        allCards.map(function (c) { return renderSessionCard_(c.session, c.planData, c.planMeta, email); }).join('') +
      '</div>';
    }
    var filter = readPlanFilter_();
    // Your plans, card grid. Each card carries a color-strip, plan
    // name, tick state, and an "open" affordance. Clicking the body
    // toggles inclusion; clicking the arrow opens the plan page.
    html += '<div class="tmb-hub-plans-section">' +
      '<h3 class="tmb-hub-plans-heading">Your plans <span class="tmb-hub-plans-count">' + planEntries.length + '</span></h3>' +
      '<p class="tmb-hub-plans-sub">Tap a plan to include or hide it in the combined view. Tap the arrow to open it.</p>' +
      '<div class="tmb-hub-plans-grid">' +
        planEntries.map(function (e) {
          if (!e.planMeta.pageUrl) return '';
          var color = planColor_(e.planMeta.planTitle);
          var planName = athleteFacingPlanName_(e.planMeta.planTitle);
          var sep = e.planMeta.pageUrl.indexOf('?') === -1 ? '?' : '&';
          var url = e.planMeta.pageUrl + sep + 'email=' + encodeURIComponent(email);
          var token = tokenFromPageUrl_(e.planMeta.pageUrl) || '';
          var included = planIsIncluded_(token, filter);
          return '<div class="tmb-hub-plan-card' + (included ? ' is-on' : ' is-off') + '"' +
            ' style="--plan-color: ' + color + '">' +
            '<label class="tmb-hub-plan-card-tap">' +
              '<input type="checkbox" class="tmb-hub-today-plan-check" data-plan-token="' + escapeHtml_(token) + '"' +
                (included ? ' checked' : '') + '>' +
              '<span class="tmb-hub-plan-card-tick" aria-hidden="true">✓</span>' +
              '<span class="tmb-hub-plan-card-name">' + escapeHtml_(planName) + '</span>' +
            '</label>' +
            '<a class="tmb-hub-plan-card-open" href="' + escapeHtml_(url) + '" aria-label="Open ' + escapeHtml_(planName) + '">&rarr;</a>' +
          '</div>';
        }).join('') +
      '</div>' +
      // Merged-plan CTA, lives BELOW the plan cards so it reads as
      // "after picking which plans to include, view them combined".
      '<a class="tmb-hub-merged-cta-card" href="/pages/training-plan-merged">' +
        '<span class="tmb-hub-merged-cta-icon" aria-hidden="true">⊕</span>' +
        '<span class="tmb-hub-merged-cta-body">' +
          '<span class="tmb-hub-merged-cta-title">See everything in one calendar</span>' +
          '<span class="tmb-hub-merged-cta-sub">All your ticked plans combined.</span>' +
        '</span>' +
        '<span class="tmb-hub-merged-cta-arrow" aria-hidden="true">→</span>' +
      '</a>' +
    '</div>';
    html += '</section>';
    return html;
  }

  // Sessions across the next N days from one plan, day-bucketed.
  function weekAheadSessionsForPlan_(plan, fromDate, days) {
    if (!plan || !plan.imports || !plan.weeks) return {};
    var byDate = {};
    var startMs = fromDate.getTime();
    for (var i = 0; i < days; i++) {
      var d = new Date(startMs + i * 86400000);
      var iso = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
      var dayCode = DAY_CODES[d.getDay()];
      var thisWeek = plan.weeks.find(function (w) {
        var s = String(w['Start Date'] || '').slice(0, 10);
        var e = String(w['End Date'] || '').slice(0, 10);
        return s && e && s <= iso && iso <= e;
      });
      if (!thisWeek) continue;
      var weekId = String(thisWeek.Week || '');
      var sessions = plan.imports.filter(function (r) {
        return String(r.Week) === weekId &&
          String(r.Day || '').toLowerCase() === dayCode;
      });
      if (sessions.length) byDate[iso] = sessions;
    }
    return byDate;
  }

  function renderWeekAhead_(planEntries, email) {
    var filter = readPlanFilter_();
    var fromDate = new Date();
    fromDate.setHours(0, 0, 0, 0);
    fromDate = new Date(fromDate.getTime() + 86400000);  // tomorrow onward
    var DAYS = 7;
    var byDate = {};
    planEntries.forEach(function (e) {
      if (!e.planData) return;
      var token = tokenFromPageUrl_(e.planMeta.pageUrl) || '';
      if (!planIsIncluded_(token, filter)) return;
      var planByDate = weekAheadSessionsForPlan_(e.planData, fromDate, DAYS);
      Object.keys(planByDate).forEach(function (iso) {
        if (!byDate[iso]) byDate[iso] = [];
        planByDate[iso].forEach(function (s) {
          byDate[iso].push({ session: s, planMeta: e.planMeta, planData: e.planData });
        });
      });
    });
    var dates = Object.keys(byDate).sort();
    if (!dates.length) return '';
    var html = '<section class="tmb-hub-week">' +
      '<header class="tmb-hub-week-header">' +
        '<h2 class="tmb-hub-week-title">Coming up</h2>' +
        '<span class="tmb-hub-week-sub">Next 7 days across your ticked plans</span>' +
      '</header>';
    dates.forEach(function (iso) {
      var d = new Date(iso + 'T00:00:00');
      var label = d.toLocaleDateString(undefined, { weekday: 'long', day: 'numeric', month: 'short' });
      var cards = byDate[iso].map(function (c) {
        return renderSessionCard_(c.session, c.planData, c.planMeta, email);
      }).join('');
      html += '<div class="tmb-hub-week-day">' +
        '<div class="tmb-hub-week-day-label">' + escapeHtml_(label) + '</div>' +
        '<div class="tmb-hub-week-day-cards">' + cards + '</div>' +
      '</div>';
    });
    html += '</section>';
    return html;
  }

  // Toggle authenticated-state UI: hide the "Enter your email…"
  // subheading (CSS) + swap the top-right CTA label from the empty-
  // state "Don't have a plan yet?" wording to a returning-user
  // "Browse plans" framing.
  function markAuthenticated_(planCount) {
    if (root) root.classList.add('tmb-hub--authenticated');
    var ctaLabel = root && root.querySelector('.tmb-hub-header-cta');
    if (!ctaLabel) return;
    // Only override the label when the user actually has plans,
    // zero-plan auth still wants the original "Join a plan" framing.
    if (planCount > 0) {
      // Preserve the arrow / chevron child if present.
      var arrow = ctaLabel.querySelector('span[aria-hidden]');
      ctaLabel.textContent = 'Browse plans ';
      if (arrow) ctaLabel.appendChild(arrow);
    }
  }

  function autoLoadMergedView_() {
    var saved = '';
    try { saved = localStorage.getItem(EMAIL_STORAGE_KEY) || ''; } catch (_e) {}
    var device = getDevice_();
    // Access is code-gated: without BOTH a saved email and a remembered-device
    // token, don't auto-load, show the email→code form instead.
    if (!saved || !device) { showStep_('email'); return; }
    // Hide the form during the auto-load, they can still toggle it back
    // via the "🔍 Find another plan by email" link in the empty state.
    if (form) form.classList.add('tmb-hub-form--minimised');
    var cached = __readLookupCache_(saved);
    // Skip the loading spinner when we've got a cached lookup, the
    // stale-while-revalidate path below paints from per-plan cache in
    // the same microtask, so a spinner would just flicker.
    if (!cached) {
      resultsEl.innerHTML = '<div class="tmb-hub-today-loading"><span class="tmb-hub-spin" aria-hidden="true"></span>Loading your plans…</div>';
    }
    var lookupPromise = cached
      ? Promise.resolve(cached)
      : fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
          body: JSON.stringify({ action: 'lookupAccess', email: saved, deviceToken: device }),
        }).then(function (r) { return r.json(); });
    lookupPromise.then(function (j) {
      if (j && j.needsCode) {
        // The remembered-device token expired or was rejected. Drop it and send
        // them back through the code step, email prefilled.
        saveDevice_('');
        resultsEl.innerHTML = '';
        if (form) form.classList.remove('tmb-hub-form--minimised');
        if (emailEl) emailEl.value = saved;
        showStep_('email');
        setStatus_('For your security, confirm it\'s you with a fresh code.', '');
        return;
      }
      if (!j || !j.ok || !j.plans || !j.plans.length) {
        // Either email no longer matches, or no plans, show the form.
        resultsEl.innerHTML = '';
        if (form) form.classList.remove('tmb-hub-form--minimised');
        if (emailEl) emailEl.value = saved;
        showStep_('email');
        return;
      }
      if (!cached) __writeLookupCache_(saved, j);
      var plans = j.plans.filter(function (p) { return p.pageUrl && tokenFromPageUrl_(p.pageUrl); });

      // Stale-while-revalidate: read cached plan JSON for every plan and
      // paint Today immediately if any are cached. Then fire revalidation
      // fetches in the background and re-render when they all return. On
      // repeat visits the first paint is essentially instant.
      // Stale-while-revalidate priming reads from the same cache key
      // fetchPlanData_ writes (token:fromIso:1).
      var fromIsoNow = todayIso_();
      var cachedEntries = plans.map(function (p) {
        var token = tokenFromPageUrl_(p.pageUrl);
        var c = token && readCachedPlanData_(token + ':' + fromIsoNow + ':1');
        return { planMeta: p, planData: c && c.data ? c.data : null };
      });
      var primed = cachedEntries.filter(function (e) { return !!e.planData; });
      if (primed.length) {
        root.__hubEntries = primed;
        root.__hubEmail = saved;
        resultsEl.innerHTML = renderMergedToday_(primed, saved);
        markAuthenticated_(primed.length);
      }

      fetchPlansLimited_(plans, function (p) {
        return fetchPlanData_(tokenFromPageUrl_(p.pageUrl), saved).then(function (data) {
          return { planMeta: p, planData: data };
        });
      }).then(function (entries) {
        // One retry pass for anything that failed, now the server is warm.
        var chain = Promise.resolve();
        entries.forEach(function (e) {
          if (e.planData) return;
          chain = chain.then(function () {
            return fetchPlanData_(tokenFromPageUrl_(e.planMeta.pageUrl), saved)
              .then(function (data) { if (data) e.planData = data; });
          });
        });
        return chain.then(function () { return entries; });
      }).then(function (entries) {
        var failedCount = entries.filter(function (e) { return !e.planData; }).length;
        entries = entries.filter(function (e) { return !!e.planData; });
        if (!entries.length) {
          // No fresh data + no primed paint → show the empty state.
          if (!primed.length) {
            resultsEl.innerHTML = '<div class="tmb-hub-today-empty">Couldn\'t load any plans. Try entering your email again below.</div>';
            if (form) form.classList.remove('tmb-hub-form--minimised');
          }
          return;
        }
        // Stash entries on the root so tickbox toggles can re-render without
        // refetching plan data.
        root.__hubEntries = entries;
        root.__hubEmail = saved;
        resultsEl.innerHTML = renderMergedToday_(entries, saved);
        if (failedCount > 0) {
          var warn = document.createElement('div');
          warn.className = 'tmb-hub-today-warning';
          warn.textContent = failedCount + ' plan' + (failedCount === 1 ? '' : 's') +
            ' didn\'t load this time. Refresh to retry.';
          resultsEl.insertBefore(warn, resultsEl.firstChild);
        }
        markAuthenticated_(entries.length);
      });
    }).catch(function (err) {
      try { window.tmbLogError && window.tmbLogError('fetch_lookupaccess_hub_auto', String(err && err.message || err), { stack: err && err.stack || '', email: saved }); } catch (_e) {}
      resultsEl.innerHTML = '';
      if (form) form.classList.remove('tmb-hub-form--minimised');
    });
  }

  // Click handler, let the empty state's "See all plans →" link toggle
  // the form back on.
  resultsEl.addEventListener('click', function (ev) {
    var target = ev.target.closest('[data-hub-show-plans]');
    if (target) {
      ev.preventDefault();
      if (form) form.classList.remove('tmb-hub-form--minimised');
    }
  });

  // Plan-filter checkbox handler, persists the toggle + re-renders the
  // Today section so the visible cards reflect the new selection.
  resultsEl.addEventListener('change', function (ev) {
    var cb = ev.target.closest('[data-plan-token]');
    if (!cb) return;
    var token = cb.getAttribute('data-plan-token') || '';
    if (!token) return;
    var filter = readPlanFilter_();
    if (cb.checked) {
      delete filter[token];
    } else {
      filter[token] = false;
    }
    writePlanFilter_(filter);
    // Re-render with cached entries if available, otherwise the next
    // autoLoadMergedView_ pass will pick up the new filter.
    if (root.__hubEntries) {
      resultsEl.innerHTML = renderMergedToday_(root.__hubEntries, root.__hubEmail);
    }
  });

  autoLoadMergedView_();
})();
